import React from "react";
import { FileUploadData } from "../../TypeScript/interfaces";

type Props = {
  fileUploadData: FileUploadData;
};

const PrinWindow = React.forwardRef(
  (props: Props, ref: React.Ref<HTMLDivElement>) => {
    const { fileUploadData } = props;

    return (
      <div id="page" ref={ref}>
        <div id="center" style={{margin: "auto",  width: "50%"}}>
          <h1 style={{ color: "#00A5C0" }}> Beneficial Ownership List </h1>

          <div className="inline" style={{ width: "25%" }}>
            Market:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.country}
          </div>
          <div className="inline" style={{ width: "25%" }}>
            Security Type:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.securityType}
          </div>
          {fileUploadData.securityName && (
            <>
              <div className="inline" style={{ width: "25%" }}>
                Security Name:
              </div>
              <div className="inline" style={{ width: "75%" }}>
                {fileUploadData.securityName}
              </div>
            </>
          )}

          <h1 style={{ color: "#00A5C0" }}> File Upload Information </h1>
          <h2 style={{ color: "#00A5C0" }}> My Contact Information </h2>

          <div className="inline" style={{ width: "25%" }}>
            Name:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.salutation +
              " " +
              fileUploadData.firstName +
              " " +
              fileUploadData.lastName}
          </div>
          <div className="inline" style={{ width: "25%" }}>
            Organization:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.customerOrg}
          </div>

          <div className="inline" style={{ width: "25%" }}>
            Telephone:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.phoneNbr}
          </div>
          <div className="inline" style={{ width: "25%" }}>
            Email:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.email}
          </div>

          <h2 style={{ color: "#00A5C0" }}>Confirmation message is sent to</h2>

          <div className="inline" style={{ width: "25%" }}>
            Email:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.email}
          </div>
          {fileUploadData.ccFirst && (
            <>
              <div className="inline" style={{ width: "25%" }}>
                CC:
              </div>
              <div className="inline" style={{ width: "75%" }}>
                {fileUploadData.ccFirst}
              </div>
            </>
          )}
          {fileUploadData.ccSecond && (
            <>
              <div className="inline" style={{ width: "25%" }}>
                CC:
              </div>
              <div className="inline" style={{ width: "75%" }}>
                {fileUploadData.ccSecond}
              </div>
            </>
          )}

          <h2 style={{ color: "#00A5C0" }}>Clearstream Account Information</h2>

          <div className="inline" style={{ width: "25%" }}>
            Account Number:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.acctNbr}
          </div>
          <div className="inline" style={{ width: "25%" }}>
            Platform:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.platform}
          </div>

          <h2 style={{ color: "#00A5C0" }}> Payment details </h2>
          {fileUploadData.country !== "Germany" && (
            <>
              <div className="inline" style={{ width: "25%" }}>
                Common Code:
              </div>
              <div className="inline" style={{ width: "75%" }}>
                {fileUploadData.commonCode}
              </div>
              <div className="inline" style={{ width: "25%" }}>
                Security Name:
              </div>
              <div className="inline" style={{ width: "75%" }}>
                {fileUploadData.securityName}
              </div>
              <div className="inline" style={{ width: "25%" }}>
                CORP Id:
              </div>
              <div className="inline" style={{ width: "75%" }}>
                {fileUploadData.corpId}
              </div>
              <div className="inline" style={{ width: "25%" }}>
                Record Date:
              </div>
              <div className="inline" style={{ width: "75%" }}>
                {fileUploadData.recordDate}
              </div>
              {fileUploadData.paymentDate && (
                <>
                  <div className="inline" style={{ width: "25%" }}>
                    Payment Date:
                  </div>
                  <div className="inline" style={{ width: "75%" }}>
                    {fileUploadData.paymentDate}
                  </div>
                </>
              )}
              {fileUploadData.grossPrice && (
                <>
                  <div className="inline" style={{ width: "25%" }}>
                    Gross Price / Unit:
                  </div>
                  <div className="inline" style={{ width: "75%" }}>
                    {fileUploadData.grossPrice}
                  </div>
                </>
              )}
              <div className="inline" style={{ width: "25%" }}>
                Total Holding:
              </div>
              <div className="inline" style={{ width: "75%" }}>
                {fileUploadData.totalHolding}
              </div>
            </>
          )}
          {fileUploadData.country === "Germany" && (
            <>
              <div className="inline" style={{ width: "25%" }}>
                Tax Year:
              </div>
              <div className="inline" style={{ width: "75%" }}>
                {fileUploadData.taxYear}
              </div>
            </>
          )}
          <h2 style={{ color: "#00A5C0" }}> Upload Information </h2>

          <div className="inline" style={{ width: "25%" }}>
            Reference Code:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.returnedReferenceCode}
          </div>
          <div className="inline" style={{ width: "25%" }}>
            Timestamp:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.returnedTimeStamp}
          </div>
          <div className="inline" style={{ width: "25%" }}>
            File:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.attachedFileName}
          </div>
          <div className="inline" style={{ width: "25%" }}>
            SIze:
          </div>
          <div className="inline" style={{ width: "75%" }}>
            {fileUploadData.attachedFileSize}
          </div>
        </div>
      </div>
    );
  }
);

export default PrinWindow;
